import type { IncotermApi, ResponseIncotermData, ResponseIncotermDataApi } from './types'

export const toIconTerm = (incotermApi: IncotermApi) => {
  return {
    description: incotermApi.descricao,
    id: incotermApi.codigo,
  }
}

export const toIncotermData = (response: IncotermApi[]) => {
  return response.map((reason) => toIconTerm(reason))
}

export const toResponseIncotermData = (
  responseIncotermDataApi: ResponseIncotermDataApi,
): ResponseIncotermData => {
  return {
    data: toIncotermData(responseIncotermDataApi.data),
    pagination: {
      currentPage: 1,
      totalItems: responseIncotermDataApi.data.length,
    },
  }
}
